import { render, staticRenderFns } from "./MergeContactSummary.vue?vue&type=template&id=a193a0c0&"
import script from "./MergeContactSummary.vue?vue&type=script&lang=js&"
export * from "./MergeContactSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports